// import AgentPanel from "../components/ai/AgentPanel.jsx";
import { useUserDetailContext } from "Components/UserDetailContext";
import { Mic, Paperclip, Phone, Send, Video } from "lucide-react";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSocket } from "services/socketService";
import {
  sendDirectMessage,
  sendGroupMessage,
  setConversations,
  setUnreadCount,
} from "../../../../../Redux/Reducers/cceReducer";
import ChatSidebar from "../components/chat/ChatSidebar";
import MessageBubble from "../components/chat/MessageBubble.jsx";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../components/ui/avatar.jsx";
import EmojiPicker from "../components/ui/emoji-picker.jsx";
import "../global.css";
import ChatInfoSheet from "../components/chat/ChatInfoSheet";
import { Info } from "lucide-react";

export default function AppChat({setIsSidebarOpen}) {
  const socket = getSocket();
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const messagesData = useSelector((state) => state?.cce?.messages);
  const [messages, setMessages] = useState([]);
  const [infoSheetOpen, setInfoSheetOpen] = useState(false);
  const groupMembersData = useSelector(
    (state) => state?.ContactArray?.groupMembersData
  );
  
  // const [unreadCount, setUnreadCount] = useState([]);
  const scrollRef = useRef(null);
  const { userDetails } = useUserDetailContext();
  const currentConversation = useSelector(
    (state) => state?.cce?.currentConversation
  );
  const conversationName = currentConversation?.title;
  const conversationAvatar = currentConversation?.avatar;
  const members = groupMembersData?.members;
  // const members = []
  const headerOverflow = "";
  const displayOnlineCount = 0;
  const headerStatus = currentConversation?.isOnline;
  const unreadCounts = useSelector((state) => state?.cce?.unreadCounts);
  // const auth = useSelector((state) => state?.auth?.auth_user);
  const groups = useSelector((state) => state?.contact?.contactGroups);
  const group = groups?.find((i) => i?.id == currentConversation?.sourceId);
  const conversations = useSelector((state) => state?.cce?.conversations);
  const isGroupThread = false;
  const dispatch = useDispatch();

  // console.log("currentConversation-1", currentConversation)

  // console.log("auth--123", unreadCounts);

  useEffect(() => {
    // Ensure the main sidebar is closed whenever the chat screen mounts
    if (typeof setIsSidebarOpen === "function") {
      setIsSidebarOpen(false);
    }
  }, [setIsSidebarOpen]);

  useEffect(() => {
    setMessages(messagesData);
  }, [messagesData]);

  useEffect(() => {
    if (socket) {
      if (currentConversation?.conversationId) {
        if (currentConversation?.sourceType == "direct") {
          socket.emit("join-conversation", currentConversation?.conversationId);
          socket.on("direct-conversation", handleNewMessage);
        } else if (currentConversation?.sourceType == "group") {
          socket.emit("join-group", currentConversation?.conversationId);
          socket.on("group-conversation", handleNewMessage);
        }
      }

      socket.on("unread-count-update", (data) => {
        const updatedCounts = unreadCounts?.map((item) => {
          if (item?.conversationId === data?.conversationId) {
            return { ...item, unreadCount: data?.unreadCount };
          } else {
            return item;
          }
        });

        dispatch(setUnreadCount(updatedCounts));
        // console.log("Updated unread count:", updatedCounts, data);
      });

      socket.on("message-status-updates", (data) => {
        console.log("updated status", data);
      });

      socket.on("show-typing", (senderReferenceId) => {
        console.log("show-typing", senderReferenceId);
        if (senderReferenceId !== userDetails?.reference_id) setTyping(true);
      });

      socket.on("hide-typing", (senderReferenceId) => {
        console.log("hide-typing", senderReferenceId);
        if (senderReferenceId !== userDetails?.reference_id) setTyping(false);
      });

      return () => {
        if (currentConversation?.conversationId) {
          if (currentConversation?.sourceType == "direct") {
            socket.emit(
              "leave-conversation",
              currentConversation?.conversationId
            );
          } else if (currentConversation?.sourceType == "group") {
            socket.emit("leave-group", currentConversation?.conversationId);
          }
        }
        socket.off("show-typing");
        socket.off("hide-typing");
      };
    }
  }, [currentConversation?.conversationId]);

  useEffect(() => {
    if (socket) {
      const mids = messages
        ?.filter((m) => !m?.is_mine && m?.status != "read")
        ?.map((m) => m?.id);
      mids?.length > 0 &&
        socket.emit("message-read", {
          messageIds: mids,
          conversationId: currentConversation?.conversationId,
          readerId: userDetails?.reference_id,
        });
    }
  }, [messages]);

  useEffect(() => {
    if (socket) {
      if (input?.length > 0) {
        socket.emit("start-typing", {
          conversationId: currentConversation?.conversationId,
          senderReferenceId: userDetails?.reference_id,
        });
      } else {
        socket.emit("stop-typing", {
          conversationId: currentConversation?.conversationId,
          senderReferenceId: userDetails?.reference_id,
        });
      }
    }
  }, [input]);

  const handleNewMessage = (data) => {
    console.log("directdata", data);
    if (!messages?.some((item) => item?.id == data?.id)) {
      setMessages((prev) => [
        ...prev,
        {
          ...data,
          is_mine: data?.sender_id == userDetails?.reference_id ? true : false,
        },
      ]);
    }
  };

  const handleSend = async () => {
    if (!input.trim()) return;

    const tempId = "msg_" + Date.now();

    const newMsg = {
      id: tempId,
      content: input,
      conversation_id: currentConversation?.conversationId,
      message_type: "text",
      status: "pending",
      is_mine: true,
      media_url: null,
      sender_id: userDetails?.reference_id,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };

    setMessages((prev) => [...prev, newMsg]);
    const updatedConversation = conversations?.map((conv) => {
      if (conv?.conversation_id === currentConversation?.conversationId) {
        return {
          ...conv,
          last_message: {
            content: input,
            created_at: new Date().toISOString(),
            id: tempId,
            status: "sent",
            type: "text",
            updated_at: new Date().toISOString(),
          },
        };
      } else {
        return conv;
      }
    });

    dispatch(setConversations(updatedConversation));

    setInput("");

    const payload = {
      conversationId: currentConversation?.conversationId,
      text: input,
      tempId,
    };

    // console.log("Iam Payload", payload);

    try {
      if (currentConversation?.sourceType == "group") {
        const response = await dispatch(sendGroupMessage(payload));
        if (response.type === sendGroupMessage.fulfilled.type) {
          setMessages((prev) =>
            prev?.map((item) =>
              item.id === tempId
                ? { ...item, status: "sent", id: response?.payload?.id }
                : item
            )
          );
        }
      }
      {
        const response = await dispatch(sendDirectMessage(payload));
        if (response.type === sendDirectMessage.fulfilled.type) {
          setMessages((prev) =>
            prev?.map((item) =>
              item.id === tempId
                ? { ...item, status: "sent", id: response?.payload?.id }
                : item
            )
          );
        }
      }
    } catch (error) {
      console.log("Error occurred", error);
    }
  };

  const messagesList = useMemo(() => {
    return messages?.map((item) => {
      const sender = groupMembersData?.members?.find(
        (member) => String(member?.contact_ref_id) === String(item?.sender_id)
      );

      const userName = `${userDetails?.firstName} ${userDetails?.lastName}`;

      return {
        senderId: item?.sender_id,
        content: item?.content,
        timeStamp: item?.updated_at || item?.created_at,
        isMine: item?.is_mine,
        status: item?.status,
        messageType: item?.message_type,
        avtar: item?.is_mine
          ? userDetails?.proFile
          : sender?.img || currentConversation?.avatar,
        name: item?.is_mine
          ? userName
          : sender?.name || currentConversation?.title,
      };
    });
  }, [messages, groupMembersData, userDetails, currentConversation]);

  // console.log("messagesList-123", messagesList);

  const openProfileFor = () => {};

  const startCall = () => {};

  const startAudio = () => {};

  const send = () => {};


  return (
    <section className="mx-auto w-full max-w-[1400px] px-2 sm:px-4 lg:px-8 py-6">
      <div className="emerald-chat-shell h-[calc(92vh-106px)] rounded-none">
        <div className="flex h-full flex-col md:flex-row">
          <div className="w-full border-[#1f2c34] md:w-[340px] md:border-r">
            <div className="h-[320px] md:h-full">
              <ChatSidebar setIsSidebarOpen={setIsSidebarOpen} />
            </div>
          </div>

          <div className="flex flex-1 flex-col bg-white text-[#0f172a]">
            <header className="flex items-center gap-3 border-b border-[#1f2c34] px-4 py-3 sm:px-6">
              <button
                type="button"
                onClick={() => {}}
                className="relative"
                aria-label="Conversation info"
              >
                <Avatar className="h-10 w-10">
                  <AvatarImage
                    src={conversationAvatar}
                    alt={conversationName}
                    referrerPolicy="no-referrer"
                  />
                  {/* <AvatarFallback>
                    {conversationName?.slice(0, 2).toUpperCase()}
                  </AvatarFallback> */}
                </Avatar>
              </button>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <div className="truncate text-base font-semibold">
                    {conversationName}
                  </div>
                  {/* <div className="rounded-full bg-[#f4f7fe] px-2 py-0.5 text-[11px] font-medium text-[#0044C6]">
                  {displayOnlineCount} online
                </div> */}
                </div>
                <div className="mt-1 flex flex-wrap items-center gap-3">
                  <div className="flex -space-x-2">
                    {currentConversation?.sourceType == "group" &&
                      members?.map((member) => (
                        <div key={member?.contact_ref_id} className="relative">
                          <Avatar className="h-8 w-8 border border-[#0b141a]">
                            <AvatarImage
                              src={
                                member?.img ||
                                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6LXNJFTmLzCoExghcATlCWG85kI8dsnhJng&s"
                              }
                              alt={member.name}
                              referrerPolicy="no-referrer"
                            />
                            <AvatarFallback>{member?.name}</AvatarFallback>
                          </Avatar>
                          {/* <span className={`absolute bottom-0 right-0 h-2 w-2 rounded-full border border-[#0b141a] ${currentConversation.isOnline ? "bg-[#25d366]" : "bg-[#8696a0]"}`} /> */}
                        </div>
                      ))}
                    {/* {headerOverflow > 0 && (
                      // <div className="flex h-8 w-8 items-center justify-center rounded-full border border-[#1f2c34] bg-[#1f2c34] text-[11px] font-semibold text-[#e9edef]">
                        +{headerOverflow}
                      </div>
                    )} */}
                    {currentConversation?.sourceType == "direct" && typing ? (
                      <span className="text-[#25d366]">typing…</span>
                    ) : (
                      currentConversation?.sourceType == "direct" &&
                      (currentConversation?.isOnline ? (
                        <span className="text-green-400 font-medium">
                          online
                        </span>
                      ) : (
                        <span className="text-red-500 font-medium">
                          offline
                        </span>
                      ))
                    )}
                  </div>
                  <div className="inline-flex items-center gap-2 text-[11px] text-[#8696a0]"></div>
                </div>
              </div>
              <div className="hidden items-center gap-2 text-[#8696a0] sm:flex">
                <button
                  type="button"
                  onClick={startAudio}
                  className="rounded-full p-2 hover:bg-[#202c33]"
                  aria-label="Start voice call"
                >
                  <Phone className="h-4 w-4" />
                </button>
                <button
                  type="button"
                  onClick={startCall}
                  className="rounded-full p-2 hover:bg-[#202c33]"
                  aria-label="Start video call"
                >
                  <Video className="h-4 w-4" />
                </button>
                <button type="button" onClick={() => setInfoSheetOpen(true)} className="rounded-full p-2 hover:bg-[#202c33]" aria-label="Conversation details">
                  <Info className="h-4 w-4" />
                </button>
              </div>
            </header>

            <div
              ref={scrollRef}
              className="emerald-chat-wallpaper flex-1 overflow-y-auto px-3 py-4 sm:px-6"
            >
              <div className="mx-auto flex max-w-3xl flex-col gap-3">
                {messagesList?.map((m, index) => (
                  <MessageBubble
                    key={index}
                    message={m} // ✅ matches the component
                    onProfileClick={() => openProfileFor(m)}
                  />
                ))}
                {typing && (
                  <div className="flex justify-start">
                    <div className="rounded-3xl bg-[#202c33] px-4 py-2 text-sm text-[#d1d7db] shadow-sm">
                      typing…
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="border-t border-[#1f2c34] px-3 py-3 sm:px-6">
              <div className="emerald-chat-composer">
                <EmojiPicker
                  onSelect={(emoji) => setInput((prev) => prev + emoji)}
                >
                  <button
                    type="button"
                    className="grid h-9 w-9 place-items-center rounded-full bg-transparent text-[#6a7ba8] hover:text-[#0044C6]"
                    aria-label="Emoji picker"
                  >
                    🙂
                  </button>
                </EmojiPicker>
                <label
                  className="grid h-9 w-9 place-items-center rounded-full bg-transparent text-[#b1b5b9] hover:text-[#e9edef] cursor-pointer"
                  aria-label="Attach file"
                >
                  <input type="file" className="sr-only" multiple />
                  <Paperclip className="h-4 w-4" />
                </label>
                <input
                  className="flex-1 bg-transparent text-sm text-[#e9edef] placeholder:text-[#8696a0] focus:outline-none"
                  placeholder="Type a message"
                  value={input}
                  onChange={(event) => setInput(event.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" && input.trim()) {
                      handleSend(input.trim());
                      setInput("");
                    }
                  }}
                />

                <button
                  type="button"
                  className="grid h-9 w-9 place-items-center rounded-full bg-transparent text-[#6a7ba8] hover:text-[#0044C6]"
                  aria-label="Record voice note"
                >
                  <Mic className="h-4 w-4" />
                </button>
                <button
                  type="button"
                  onClick={() => {
                    if (input.trim()) {
                      handleSend(input.trim());
                      setInput("");
                    }
                  }}
                  className="grid h-10 w-10 place-items-center rounded-full bg-[#25d366] text-[#0b141a] hover:bg-[#2ecc71]"
                  aria-label="Send message"
                >
                  <Send className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {infoSheetOpen && <ChatInfoSheet infoSheetOpen={infoSheetOpen} setInfoSheetOpen={setInfoSheetOpen} />}
    </section>
  );
}
